import React from 'react';

interface StatCardProps {
  title: string;
  value: number|null;
}

const  StatCard: React.FC<StatCardProps> = ({ title, value }) => {
  return (
    <div className="flex items-center flex-1 p-4 bg-white rounded-2xl shadow-md min-w-[200px]">
      <div className="flex items-baseline gap-1.5 p-2.5 text-lg">
        <span className="text-gray-600">{title}:</span>
        <span className="font-semibold text-gray-900">{value}</span>
      </div>
    </div>
  );
};

export default StatCard;
